import AppointmentOverview from '../../components/AppointmentOverview/AppointmentOverview';
import CommonButton from '../../components/CommonButton';
import { ICreateAppointmentBuilder } from '../../hooks/useCreateAppointmentRequest';
import { AttendanceStatus } from './enums';
import { consultationTypeRequiresFollowUp } from './helpers';

interface IRegisterAppointmentReviewProps {
  builder: ICreateAppointmentBuilder;
  onEditClick: () => void;
  onSubmitClick: () => void;
  attendanceStatus: AttendanceStatus;
}

export default function RegisterAppointmentReview({
  builder,
  onEditClick,
  onSubmitClick,
  attendanceStatus,
}: IRegisterAppointmentReviewProps) {
  return (
    <div>
      <p className="mt-8 text-center text-subtitle">
        Ensure that the information below has been entered correctly.
      </p>
      <AppointmentOverview
        fcpName={builder.fcpName}
        dateOfConsultation={builder.dateOfConsultation}
        doubleAppointment={builder.doubleAppointment}
        organisation={builder.organisation?.organisationDescription ?? ''}
        pcnName={builder.pcnName}
        icsCcgName={builder.icsCcgName}
        referralSource={builder.referralSource?.referralSourceDescription ?? ''}
        modeOfContact={builder.modeOfContact?.modeOfContactDescription ?? ''}
        consultationType={
          builder.consultationType?.consultationTypeDescription ?? ''
        }
        consultationOutcomes={builder.consultationOutcomes.map((x) => {
          if (
            x.consultationOutcomeId ===
            Number(process.env.REACT_APP_OUTCOME_OTHER_BOX_ID)
          )
            return builder.customConsultationOutcome;

          if (x.subOutcomes.length > 0)
            return `${x.selectedSubOutcome?.consultationSubOutcomeDescription} (${x.consultationOutcomeDescription})`;

          return x.consultationOutcomeDescription;
        })}
        attendanceStatus={attendanceStatus}
        followUpMethod={builder.followUpMethod?.followUpMethodDescription ?? ''}
        followUpReason={builder.followUpReason?.followUpReasonDescription ?? ''}
        showFollowUpInfo={consultationTypeRequiresFollowUp(
          builder.consultationType?.consultationTypeId
        )}
        patientAgeRange={
          builder.patientAgeRange?.patientAgeRangeDescription ?? ''
        }
        doubleAppointmentReason={
          builder.doubleAppointment
            ? builder.doubleAppointmentReason
                ?.doubleAppointmentReasonDescription
            : ''
        }
        interpreterRequired={builder.interpreterRequired}
      />
      <div className="flex justify-between mx-auto mt-8 w-96">
        <CommonButton text="Edit" variant="outline" onClick={onEditClick} />
        <CommonButton text="Submit" variant="filled" onClick={onSubmitClick} />
      </div>
    </div>
  );
}
